'use client';
import { HTMLProps, forwardRef } from 'react';
import { requestYmmModal } from '@/packages/sxm/ymm/ymmModalEvent';

export interface LinkProps extends HTMLProps<HTMLAnchorElement> {
    children?: React.ReactNode;
    dataCy?: string;
    buttonType?: string;
}

export const Link = forwardRef<HTMLAnchorElement, LinkProps>(function (props, ref) {
    const { dataCy, children, ...rest } = props;

    if (props.buttonType === 'YMM') {
        return (
            <a
                ref={ref}
                href="#ymmModal"
                {...rest}
                data-cy={dataCy || 'atoms-link'}
                onClick={(e) => {
                    e.preventDefault();
                    requestYmmModal();
                }}
            >
                {children}
            </a>
        );
    } else {
        return <a ref={ref} {...rest} data-cy={dataCy || 'atoms-link'}>{children}</a>;
    }
});

Link.displayName = 'Link';
